import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerFatturazioneGeneratePackagePAModalComponent } from './worker-fatturazione-generate-package-pa-modal';

export const WorkerFatturazioneGeneratePackagePAModalModule: string = ng
    .module('worker-fatturazione-generate-package-pa-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerFatturazioneGeneratePackagePAModalComponent', WorkerFatturazioneGeneratePackagePAModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/worker-fatturazione-generate-package-pa-modal/worker-fatturazione-generate-package-pa-modal.module.ts